import { Database, Brain, Shield, TrendingUp, Users, Zap } from "lucide-react"

const features = [
  {
    icon: Database,
    title: "Data Aggregation Engine",
    description:
      "Unified data from DNOs, REPD, NESO, and planning portals with clear source labeling and real-time updates.",
  },
  {
    icon: Brain,
    title: "AI Query Layer",
    description:
      'Natural language questions with instant, verifiable answers. Ask "Which solar projects await connection in UKPN?" and get cited results.',
  },
  {
    icon: TrendingUp,
    title: "Gate 2 Prediction Engine",
    description:
      "Project-level readiness scoring with High/Medium/Low likelihood classification and confidence percentages.",
  },
  {
    icon: Shield,
    title: "Strategically Aligned",
    description:
      "Clean Power 2030 alignment scoring by technology and region to identify projects in optimal market conditions.",
  },
  {
    icon: Users,
    title: "Team Collaboration",
    description:
      "Work alongside colleagues, sharing reports, intelligence and Acquisition targets.",
  },
  {
    icon: Zap,
    title: "Seamless Integrations",
    description:
      "Connect Kanu intelligence into existing systems and workflows through apis and exports.",
  },
]

export default function FeaturesSection() {
  return (
    <section id="features" className="py-24 sm:py-36 bg-white">
      <div className="max-w-6xl mx-auto px-6 sm:px-10">

        {/* Header */}
        <div className="mb-20">
          <div className="w-10 h-0.75 bg-secondary mb-8 rounded-full" />
          <h2 className="text-4xl sm:text-6xl font-black text-[#0D0D0D] tracking-tight leading-[1.05] text-balance mb-5">
            {"Unified intelligence stack"}
          </h2>
          <p className="text-lg text-[#0D0D0D]/55 max-w-2xl leading-relaxed">
            {
              'Everything you need to make confident investment decisions under the new "first ready, first connected" paradigm.'
            }
          </p>
        </div>

        {/* Features grid — gap-px creates crisp 1px architectural dividers */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#0D0D0D]/10">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white p-8 sm:p-10 group hover:bg-[#1D591B] transition-colors duration-300 cursor-default"
            >
              <feature.icon className="h-7 w-7 text-[#1D591B] group-hover:text-secondary mb-8 transition-colors duration-300" />
              <h3 className="text-lg font-bold text-[#0D0D0D] group-hover:text-white mb-3 transition-colors duration-300">
                {feature.title}
              </h3>
              <p className="text-[#0D0D0D]/55 group-hover:text-white/65 leading-relaxed text-sm transition-colors duration-300">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

      </div>
    </section>
  )
}
